export default __webpack_public_path__ + "static/media/budapest-restaurant.c5e664f1.png";